import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { MobileBottomBar } from "./MobileBottomBar";
import { useGetAppConfig } from "@/hooks";
import { SetSrc } from "@/utils";
import { InstallPrompt } from "@/components/InstallPrompt";

interface LayoutProps {
  children: ReactNode;
}

// Routes that render as immersive, standalone experiences (no navbar / no bottom bar).
const IMMERSIVE_ROUTES = new Set<string>(["/menu", "/full-menu", "/kids"]);

export const Layout = ({ children }: LayoutProps) => {
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const location = useLocation();

  // Routes that render as immersive, standalone experiences (no navbar / no bottom bar).
  // Normalise the pathname so "/menu/" matches "/menu"
  const normalisedPath = location.pathname.replace(/\/+$/, "") || "/";
  const isImmersive = IMMERSIVE_ROUTES.has(normalisedPath);

  const { data: appConfigData } = useGetAppConfig({ enabled: !isImmersive });
  const branch = appConfigData?.data?.branch;

  const logoUrl = branch?.logo_url ? SetSrc(branch.logo_url) : undefined;
  const name = branch?.name || "Sewar Restaurant";



  return (
    <div className="relative min-h-screen">
      <div className="relative z-10">
        {!isImmersive && (
          <Navbar
            logo={"/images/logo-new.png"}
            name={name || "Restaurant"}
          />
        )}
        <main className="min-h-screen">{children}</main>
        {!isImmersive && <Footer />}
        {!isImmersive && <MobileBottomBar />}
        <InstallPrompt />
      </div>
    </div>
  );
};
